import { convertAttributesToBoolean, mapKeysToCamelCase } from '@skytech/utils'

import { API_ROUTE_ADMIN_COST_OBJECT } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { CostObjectDetailsOriginal } from './types'

export async function getCostObjectDetails(id: number) {
  const costObjectDetails = await get<CostObjectDetailsOriginal>(
    API_ROUTE_ADMIN_COST_OBJECT.replace(':costObjectId', String(id))
  )
  const camelCaseCostObjectDetails = mapKeysToCamelCase(costObjectDetails)
  const parsedEcomPolicySubs = camelCaseCostObjectDetails.ecomPolicySubscriptions.map(policy =>
    convertAttributesToBoolean(policy, ['isGlobal', 'isLocked'])
  )
  const parsedCostObjectDetails = convertAttributesToBoolean(camelCaseCostObjectDetails, 'isHidden')
  const parsedEmployeeConsent = parsedCostObjectDetails.consent
    ? convertAttributesToBoolean(parsedCostObjectDetails.consent, 'isConsentGiven')
    : null

  return {
    ...parsedCostObjectDetails,
    ecomPolicySubscriptions: parsedEcomPolicySubs,
    consent: parsedEmployeeConsent,
  }
}
